import type { FromBaseInventoryMetadata } from './from-base-inventory';
import type { IntegerRollupMetadata } from './integer-layer-rollup';
import type { StatusLayeringMetadata } from './status-layering';
import { statusIntegerWalkLayers } from './status-residue-layers';

type Raw = FromBaseInventoryMetadata & IntegerRollupMetadata & {
    quantityEntries: { item_id: string }[];
    allEssences?: { variable_name: string; item_id: string }[];
    speedTypes: FromBaseInventoryMetadata['baseSpeed']['speedTypes'];
    statusCatalog: { variable_name: string; item_id: string }[];
    teamCatalog: { variable_name: string; item_id: string }[];
    presenceDefenseLayers: string[]; stackScaledResidueLayers: string[];
};

/** Catalog selection is raw input; rule membership predicates execute here in the browser. */
export function inventoryRuntimeMetadata(raw: Raw): FromBaseInventoryMetadata {
    const ids = (rows: { variable_name: string; item_id: string }[]): Record<string, string> =>
        Object.fromEntries(rows.map(row => [row.variable_name, row.item_id]));
    const integerRollup: IntegerRollupMetadata = { ...raw, essences: raw.essences ?? ids(raw.allEssences ?? []) as IntegerRollupMetadata['essences'],
        quantityIds: raw.quantityEntries.map(row => row.item_id) };
    const teams = ids(raw.teamCatalog);
    const statusLayering: StatusLayeringMetadata = {
        statusIds: ids(raw.statusCatalog), teamIds: { friend: teams.friend!, enemy: teams.enemy!, neutral: teams.neutral! }, dynamicLayers: raw.dynamicLayers,
        integerWalkLayers: statusIntegerWalkLayers(raw),
        presenceDefenseLayers: raw.presenceDefenseLayers, stackScaledResidueLayers: raw.stackScaledResidueLayers,
        quantityIds: integerRollup.quantityIds, contestMarker: '__janus_contest_success_immunity_until_long_rest__',
    };
    return { ...raw, definitionLayerOrder: Object.keys(raw.layerCatalog), integerRollup, statusLayering,
        baseSpeed: { ...integerRollup, speedTypes: raw.speedTypes } };
}
